import { render, staticRenderFns } from "./CharCount.vue?vue&type=template&id=5cccddc3&"
import script from "./CharCount.vue?vue&type=script&lang=js&"
export * from "./CharCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports